const ResCon = ((props) => {
    return (
        <>
            <div className={`app-circle ${props.type == 'r' && 'red'} ${props.type == 'b' && 'blue'}`}>{props.text}</div>
        </>
    )
});

export default ResCon;